// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { initializeFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// src/firebase.js
const firebaseConfig = {
  apiKey: "AIzaSyC-LC0meTRyf50zFREASG6DsLKl4WU1DF8",
  authDomain: "bobquiz-272a7.firebaseapp.com",
  projectId: "bobquiz-272a7",
  storageBucket: "bobquiz-272a7.firebasestorage.app",
  messagingSenderId: "386315002426",
  appId: "1:386315002426:web:d6f8e711e4365f135bcb03",
  measurementId: "G-CGTEVK7FHJ"
};




const app = initializeApp(firebaseConfig);
export const db = initializeFirestore(app, {
  experimentalForceLongPolling: true,
  useFetchStreams: false,
});
export const storage = getStorage(app);
export const auth = getAuth(app);    // <--- ADD THIS LINE
